import LatestHighlights from "./LatestHighlights";
export default LatestHighlights;
